import React from 'react';
import styled from '@emotion/styled';
import { withPrefix } from "gatsby";

const Wrapper = styled.div({
  display: 'flex',
  fontSize: 24
});
export default function Logo() {
  return (
    <Wrapper>
      <img className="logo"
        style={{
          margin: '0 auto',
          width: '80px',
          height: 'auto'
        }}
        src={withPrefix("/radicalbit_glyph.svg")}
        alt={"Radicalbit Logo"}
      />
    </Wrapper>
  );
}